import firehydrantAPI from 'helpers/firehydrantAPI';

import { useListQuery } from '../common/index';

const RESOURCE_NAME =
  'runbooks/select_options/patchy/page_people/targets?per_page=1000';
const RESOURCE = [{ resource: RESOURCE_NAME }];

export const usePagingOptions = (params = {}, options = {}) =>
  useListQuery(
    RESOURCE,
    params,
    () => firehydrantAPI.get(RESOURCE_NAME, { params }),
    options,
  );
